module.exports = __webpack_public_path__ + "static/media/App Store.0b3c9250.png";